module.exports = __webpack_public_path__ + "media/integrations/ebay_right-297ce1b5.svg";